import React from 'react';

import App from './App';
import './i18n';
import { PostHogProvider } from 'posthog-js/react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

const postHogOptions = {
  api_host: import.meta.env.VITE_POSTHOG_HOST,
  session_recording: {
    maskTextSelector: '.sensitive'
  }
};

const container = document.getElementById('root');
const root = createRoot(container!);

const app = import.meta.env.PROD ? (
  <React.StrictMode>
    <HelmetProvider>
      <PostHogProvider
        apiKey={import.meta.env.VITE_POSTHOG_KEY}
        options={postHogOptions}
      >
        <App />
      </PostHogProvider>
    </HelmetProvider>
  </React.StrictMode>
) : (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

root.render(app);
